<template>
  <div class="login animated bounceInLeft">
    <span class="iconfont icon-fanhui back" @click="goback"></span>
    <h2 class="welcome">欢迎登录</h2>
    <div class="usermsg">
      <div class="msgList">
        <span class="iconfont icon-yonghu"></span>
        <van-field v-model="phone" placeholder="请输入手机号" clearable />
      </div>
      <div class="msgList">
        <span class="icon-mima iconfont"></span>
        <van-field v-model="pass" type="password" clearable placeholder="请输入密码" />
      </div>
      <!-- <p class="forget" @click="$router.push('/find')">忘记密码</p> -->
      <p class="forget" @click="toForgetPage">忘记密码</p>
    </div>
    <div class="radio_btn">
      <van-radio-group v-model="memberType" direction="horizontal" @change="onChangeRadio">
        <!-- <van-radio name="0">普通会员</van-radio> -->
        <van-radio name="1">爱心企业</van-radio>
      </van-radio-group>
    </div>
    <div class="edit_btn">
      <van-button
        type="danger"
        round
        class="login_btn"
        size="small"
        @click="login"
        :disabled="isLogin"
      >登 录</van-button>
      <p v-show="rigisterShow" @click="$router.push(`/register`)">注册普通会员账号</p>
      <p v-show="!rigisterShow" @click="$router.push(`/apply`)">注册爱心企业账号</p>
    </div>
  </div>
</template>

<script>
import useApi from '@/api/wishToken'
import authApi from '@/api/auth'
import { Toast } from "vant";
import Bus from "../../bus";
export default {
  data() {
    return {
      phone: "",
      pass: "",
      isLogin: false,
      memberType: '1', // 登录会员的类型
      rigisterShow: false, // 根据会员登录类型显示哪个注册按钮 当前表示爱心企业
      loginStr: 'app/ap_member//auth/login', // 会员登录的接口部分
      userInfoStr: 'app/ap_member//member/query_info?memberId=&regionId=&id=', // 获取会员信息的接口部分
      loginForm: {},
      loginWishForm: {}
    };
  },
  mounted() {
    if (localStorage.userMsg) { // 注册成功的信息
      const userMsg = JSON.parse(localStorage.userMsg);
      if (userMsg) {
        this.phone = userMsg.username;
        this.pass = userMsg.password;
      }
    }
  },
  methods: {
    goback() {
      this.$router.go(-1); //返回上一级
    },
    // 点击单选框更换登录接口
    onChangeRadio(name) {
      console.log(name);
      if (name === '1') {
        this.rigisterShow = false;
        this.loginStr = 'app/ap_member//auth/wish/login';
        this.userInfoStr = 'app/ap_member//wish/member/query/wish/info?wishMemberId=';
      }
      if (name === '0') {
        this.rigisterShow = true;
        this.loginStr = 'app/ap_member//auth/login';
        this.userInfoStr = 'app/ap_member//member/query_info?memberId=&regionId=&id='
      }
      // console.log(this.loginStr);
    },
    login() {
      if (!this.phone) {
        Toast("请输入手机号");
        return;
      }
      if (!this.pass) {
        Toast("请输入密码");
        return;
      }
      if (!this.memberType) {
        Toast("请选择会员类型");
        return;
      }
      this.isLogin = true;
      if (this.pass) {
        // const password = window.btoa(`${Date.now()}-${this.pass}`);
        // 普通会员登录表单
        const loginCommonForm = {
          address: "",
          appName: this.appName,
          latitude: "",
          longitud: "",
          no: "",
          password: this.pass,
          phone: this.phone,
          sys: "",
          type: 0,
          version: ""
        };
        // 爱心企业登录表单
        const loginWishForm = {
          appName: this.appName,
          password: this.pass,
          phone: this.phone,
        };
        if (this.rigisterShow) {
          this.loginForm = loginCommonForm;
          this.loginWishForm = {}
        } else {
          this.loginForm = {};
          this.loginWishForm = loginWishForm;
          authApi.wishLogin(this.loginWishForm).then(res => {
            this.isLogin = false;
            if (res.code === 10000) {
              // alert(res.data.token);
              //window.localStorage.wishinfo = JSON.stringify(res.data);
              // 改变token值
              window.localStorage.userinfo = JSON.stringify(res.data);
              // Bus.$emit("webrefresh", '');
              this.getMemberInfo();
            } else {
              Toast(res.message);
            }
          }).catch(err => {
            this.isLogin = false;
            Toast("无法登陆，请刷新后重试");
          });
        }
      }
    },
    // 根据token值获取会员或企业信息
    getMemberInfo() {
      useApi.wishInfomatin({ wishMemberId: '' }).then(res => {
        console.log(res);
        if (res.success) {
          const data = JSON.stringify(res.data);
          window.localStorage.enterpriseInfo = data;
          // this.returnPage(); // 登入成功后返回上一个界面
          this.$router.go(-1); //返回上一级
        }
      }).catch(err => {
        console.log(err);
      });
    },
    // 根据身份进入忘记密码页
    toForgetPage() {
      // 普通会员
      if (this.rigisterShow) {
        this.$router.push('/find');
      } else {
        // 爱心企业
        this.$router.push({ path: '/find', query: { wishSign: 'wishSign' } })
      }

    }
  }
};
</script>

<style lang="less">
.login {
  padding: 0 20px;
  box-sizing: border-box;
  .back {
    font-size: 20px;
    position: absolute;
    left: 10px;
    top: 40px;
    z-index: 999;
  }
  .forget {
    text-align: right;
    color: #ccc;
    margin-top: 20px;
  }
  .radio_btn {
    margin-top: 5vw;
    display: flex;
    justify-content: center;
  }
  .edit_btn {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .login_btn,
    p {
      max-width: 130px;
    }
    .login_btn {
      margin: 40px auto 20px;
    }
    p {
      color: #e42417;
      font-size: 16px;
    }
  }
  .login_btn {
    padding: 0 30px;
    font-size: 16px;
  }
  .usermsg {
    margin-top: 65px;
    padding: 0 15px;
    box-sizing: border-box;
    .msgList {
      display: flex;
      justify-content: left;
      align-items: center;
      border-bottom: 1px solid #eee;
    }
  }
  .welcome {
    font-size: 20px;
    font-weight: 700;
    margin-top: 80px;
  }
}
</style>